import { render, staticRenderFns } from "./JwJiaocaiKucunSelectCourse.vue?vue&type=template&id=5b19e036&scoped=true"
import script from "./JwJiaocaiKucunSelectCourse.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiKucunSelectCourse.vue?vue&type=script&lang=js"
import style0 from "./JwJiaocaiKucunSelectCourse.vue?vue&type=style&index=0&id=5b19e036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19e036",
  null
  
)

export default component.exports